import { ca } from '@cian/analytics';

/**
 * Расхлоп на лендинге по кнопке "Позвонить консультанту"
 * https://conf.cian.tech/pages/viewpage.action?pageId=1319910433
 */
export const trackKpnCallClick = () => {
  ca('eventSite', {
    action: 'Open_newbuilding_consultant',
    category: 'Phones',
    label: '/sale/flat/object_type=2/from_developer=1/',
    name: 'oldevent',
  });
};
